// Custom code: hover zoom
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".product-media--image-hover-zoom")
    .forEach((container) => {
      const img = container.querySelector("img");

      container.addEventListener("mousemove", function (event) {
        const { left, top, width, height } = container.getBoundingClientRect();
        const x = ((event.clientX - left) / width) * 100;
        const y = ((event.clientY - top) / height) * 100;

        img.style.transform = "scale(2)";
        img.style.transformOrigin = `${x}% ${y}%`;
      });

      container.addEventListener("mouseleave", function () {
        img.style.transform = "scale(1)";
      });
    });
});
